export default function CTAFinal() {
  const handleCTA = () => {
    const ofertaSection = document.getElementById('oferta-especial');
    ofertaSection?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative py-32 bg-gradient-to-b from-black via-zinc-950 to-black overflow-hidden">
      {/* Background Effect */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/7cc8a11e7a0fa0716a9c18a034d8b062.jpg"
          alt="Background"
          className="w-full h-full object-cover object-top opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/70 to-black/80"></div>
      </div>

      <div className="relative max-w-4xl mx-auto px-6 text-center">
        {/* Icon */}
        <div className="flex justify-center mb-8">
          <div className="w-24 h-24 flex items-center justify-center bg-orange-500 animate-pulse">
            <i className="ri-fire-fill text-5xl text-black"></i>
          </div>
        </div>

        {/* Title */}
        <h2 className="text-4xl md:text-6xl font-black text-white mb-6 leading-tight">
          Seu Ampero pode soar<br />
          <span className="text-orange-500">muito mais agressivo.</span>
        </h2>

        {/* Description */}
        <p className="text-xl md:text-2xl text-gray-300 mb-12 max-w-2xl mx-auto leading-relaxed">
          Leve agora um arsenal completo de high gain profissional pelo preço de um pedal barato.
        </p>

        {/* Stats */}
        <div className="grid grid-cols-3 gap-6 mb-12 max-w-2xl mx-auto">
          <div className="bg-zinc-950/80 border border-zinc-800 p-6">
            <div className="text-4xl font-black text-orange-500 mb-2">191</div>
            <div className="text-sm text-gray-400 uppercase tracking-wider">Captures</div>
          </div>
          <div className="bg-zinc-950/80 border border-zinc-800 p-6">
            <div className="text-4xl font-black text-orange-500 mb-2">11</div>
            <div className="text-sm text-gray-400 uppercase tracking-wider">Amplificadores</div>
          </div>
          <div className="bg-zinc-950/80 border border-zinc-800 p-6">
            <div className="text-4xl font-black text-orange-500 mb-2">25+</div>
            <div className="text-sm text-gray-400 uppercase tracking-wider">Anos de Exp.</div>
          </div>
        </div>

        {/* CTA Button */}
        <button
          onClick={handleCTA}
          className="group relative inline-flex items-center justify-center px-16 py-7 text-2xl font-black text-black bg-orange-500 hover:bg-orange-600 transition-all duration-300 transform hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer"
        >
          <i className="ri-fire-fill mr-3 text-3xl"></i>
          QUERO ESSE CAPTURE AGORA
        </button>

        <p className="mt-6 text-sm text-gray-500">
          Apenas R$ 67,90 • Download imediato • Garantia de 7 dias
        </p>
      </div>
    </section>
  );
}
